<mat-table [dataSource]="dataSource" class="border-light-grey">
  <ng-container matColumnDef="product">
    <mat-header-cell mat-header-cell *matHeaderCellDef> {{'REGISTRATION.STEP.PAYMENT.PRODUCT' | translate |
      uppercase}}
    </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element">
      @if (element.product.productImg!==null) {
        <div class="product-image">
          <img [src]="element.product.productImg">
          @if (element.product.optionImg!==null) {
            <img [src]="element.product.optionImg">
          }
        </div>
      }
      @if (element.product.name.includes('subscription')) {
        <p class="product">
          {{element.product.label}}
        </p>
      } @else {
        <p class="line" [ngClass]="{'text-center':element.product.productImg!==null,'text-uppercase':element.product.productImg===null}">
          <strong>{{element.product.label}}</strong>
        </p>
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="subtotal">
    <mat-header-cell mat-header-cell *matHeaderCellDef class="header-align-right">
    {{'REGISTRATION.STEP.PAYMENT.SUB_TOTAL' | translate | uppercase}}</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element" class="text-right">
    {{element.subtotal | currency:'EUR':'symbol':'1.2-2':'fr'}}</mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
